export default defineNuxtPlugin((nuxtApp) => {
  // Only import carousel on client-side
  if (process.client) {
    import("vue3-carousel/dist/carousel.css");
  }
});
